import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton, TextField } from "material-ui"
import strings from "../../localization/strings"
import { IClientDocument } from "../../models"
import AccountStore from "../../stores/AccountStore"
import HierarchySettingsStore from "../../stores/HierarchySettingsStore"
import HierarchyItemChip from "../../components/hierarchy/HierarchyItemChip"
import * as utils from "../../helpers/utils"
import * as api from "../../api"
interface IProps {
  handleClose(): void
  handleAdd(client: IClientDocument): void
}
interface IState {
  name: string
  errorName: string,
  isSaving: boolean
}

export default class AddClientDialog extends React.Component<IProps, IState> {
  private hierarchyId = HierarchySettingsStore.getGlobalLevelItemFilterId() ? HierarchySettingsStore.getGlobalLevelItemFilterId() : null
  constructor(props: IProps) {
    super(props)
    this.state = {
      name: "",
      errorName: "",
      isSaving: false
    }
    autobind(this)
  }

  async handleSave() {
    this.setState({isSaving: true})
    const payload = {
      Id: utils.guid(),
      Name: this.state.name.trim(),
      HierarchyId: this.hierarchyId,
      AccountId: AccountStore.getCurrentAccount().Id
    } as IClientDocument

    const checkResult = await this.checkValidate()
    this.setState({isSaving: false})
    checkResult && this.props.handleAdd(payload)
  }

  checkValidate() {
    return !this.state.name.trim() ?
      new Promise((fulfill, reject) => {
        this.setState({ errorName: strings.NameRequired })
        fulfill(false)
      }) :
      api.checkClientNameValid(this.state.name.trim()).then(res => {
        this.setState({ errorName: res.data ? "" : strings.Name_is_duplicated })
        return res.data
      })
  }

  render() {
    return (
      <Dialog
        open
        title={strings.Add_Client}
        titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
        actions={[
          <FlatButton
            label={strings.CANCEL}
            secondary
            onClick={this.props.handleClose}
          />,
          <FlatButton
            label={strings.SAVE}
            primary
            disabled={this.state.isSaving}
            onClick={this.handleSave}
          />
        ]}
      >
        <div style={{ paddingRight: 20, paddingLeft: 20 }}>
          <div>
            <HierarchyItemChip
              title={strings.HierarchyLevel}
              hierarchyItemId={HierarchySettingsStore.getGlobalLevelItemFilterId()}
              maxWidth={700}
            />
          </div>
          <TextField
            floatingLabelText={strings.Name}
            value={this.state.name}
            onChange={(e, value) => { this.setState({ name: value }, () => this.checkValidate()) }}
            errorText={this.state.errorName}
            errorStyle={{ position: "absolute", bottom: -10 }}
            fullWidth={true}
          />
        </div>
      </Dialog>
    )
  }
}